import { HostContext } from "@buzzeasy/shared-frontend-utilities";
import { PropsWithChildren, ReactElement, useContext, useMemo } from "react";
import { Provider } from "react-redux";
import { createStore } from "../../redux/store";
import ThemeProviders from "./theme/ThemeProviders";
import TranscriptHubProvider, { TranscriptHubProviderProps } from "./TranscriptHubProvider";
import TranslationProvider from "./TranslationProvider";

export type ProvidersProps = PropsWithChildren<TranscriptHubProviderProps>;

export default function Providers({ children, conversationId }: ProvidersProps): ReactElement {
  const { apiBaseUrl, token } = useContext(HostContext);

  const store = useMemo(
    () => createStore(apiBaseUrl, token),
    [apiBaseUrl, token],
  );

  return (
    <Provider store={store}>
      <TranslationProvider>
        <ThemeProviders>
          <TranscriptHubProvider conversationId={conversationId}>
            {children}
          </TranscriptHubProvider>
        </ThemeProviders>
      </TranslationProvider>
    </Provider>
  );
}
